"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var MyCheckbox = function (_a) {
    var name = _a.name, onChange = _a.onChange, checked = _a.checked, id = _a.id, _b = _a.color, color = _b === void 0 ? 'primary' : _b;
    var isChecked = checked;
    return (react_1["default"].createElement(core_1.Checkbox, { color: color, checked: isChecked, id: id ? id : name.toString(), onChange: function (v) {
            return onChange({ name: name.toString(), value: v.target.checked });
        } }));
};
exports["default"] = MyCheckbox;
